import { Box, Button, Divider, Group, Title } from "@mantine/core";
import React, { useState } from "react";
import MantineTabs from "./components/tabs/tabs";
// import CardAdmin from "./components/users/components/card";

export default function AdminDashboard() {
  const [opened, setOpened] = useState(false);
  return (
    <Box>
      <Group position="apart" mb="md">
        <Title order={2}>AdminDashboard</Title>
      </Group>
      <Divider mb="md" />

      {/* <SuperAdminDashboard /> */}
      <MantineTabs />
    </Box>
  );
}
